export const ELEARNING_WEEKS_DEFAULT = 4;
export const NEGATIVE_EVENT_WEEKS_OFFSET = 4; // When creating an event we can only create them for max 1 month ago.

export const COURSE_STATE_OPEN = "open";
export const COURSE_STATE_ENDED = "ended";
export const COURSE_STATE_FINISHED = "finished";
export const COURSE_STATE_CANCELLED = "cancelled";

export const EVENT_TYPE_TRANSLATIONS = {
    elearning: "e-learning",
    practice: "praktijk",
    "knowledge-exam": "kennistoets"
};

export const eventTypeToNL = (type) => {
    return EVENT_TYPE_TRANSLATIONS?.[type] || type;
};

// API uses these constants for gender. NULL for other/unknown.
export const GENDER_MALE = "m";
export const GENDER_FEMALE = "f";

export const GENDER_ABBREVIATIONS = {
    [GENDER_MALE]: "M",
    [GENDER_FEMALE]: "V"
};

export const USER_ROLE_CERTIFICATION = "certification";
export const USER_ROLE_DEVELOPMENT_AND_ADVICE = "development-and-advice";
export const USER_ROLE_TRAINER_CONTACT = "trainer-contact";
export const USER_ROLE_INSTRUCTOR = "instructor";
export const USER_ROLE_AUDITOR = "auditor";
export const USER_ROLE_STUDENT = "student";

export const USER_ROLE_NAMES = {
    [USER_ROLE_CERTIFICATION]: "Certificering",
    [USER_ROLE_DEVELOPMENT_AND_ADVICE]: "Ontwikkeling & Advies",
    [USER_ROLE_TRAINER_CONTACT]: "Contactpersoon opleider",
    [USER_ROLE_INSTRUCTOR]: "Instructeur",
    [USER_ROLE_AUDITOR]: "Controleur",
    [USER_ROLE_STUDENT]: "Cursist",
};

const ORDERED_USER_ROLES = [
    USER_ROLE_CERTIFICATION,
    USER_ROLE_DEVELOPMENT_AND_ADVICE,
    USER_ROLE_TRAINER_CONTACT,
    USER_ROLE_INSTRUCTOR,
    USER_ROLE_AUDITOR,
    USER_ROLE_STUDENT,
];

// Array of [role, name] tuples of all available roles:
export const ALL_USER_ROLE_NAMES = ORDERED_USER_ROLES.map((role) => [role, USER_ROLE_NAMES[role]]);

// Array of all valid roles:
export const VALID_USER_ROLES = ORDERED_USER_ROLES.filter((role) => role !== USER_ROLE_STUDENT);

// Array of [role, name] tuples, of all valid roles:
export const VALID_USER_ROLE_NAMES = ALL_USER_ROLE_NAMES.filter(([role]) => VALID_USER_ROLES.includes(role));

// Array of all staff roles:
export const STAFF_USER_ROLES = [USER_ROLE_CERTIFICATION, USER_ROLE_DEVELOPMENT_AND_ADVICE];

// Array of all trainer roles:
export const TRAINER_USER_ROLES = [USER_ROLE_TRAINER_CONTACT];
